export default {
  general: {
    showFavourites: false,
    showArtistImpressionText: true,
    showSoldNeighbourhoods: false,
    showSoldLabel: false,
    showSoldPrice: false,
    showSoldSlides: false,
    canInteractSoldLivingoptions: false,
    canInteractSoldProperties: false,
    appResetTimeoutMinutes: 15,
  },

  filter: {
    enabled: false,
  },

  packagePage: {
    active: true,
    label: "",
  },
};
